import { useEffect, useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Form, Button, Modal, ToggleButton, ToggleButtonGroup, Alert } from "react-bootstrap";
import { ToastContainer, toast, Slide } from 'react-toastify';
import axios from "axios";
import psgc from "@dropdowns/psgc";
import AvatarEditor from 'react-avatar-editor';
import "../styles/FormRequest.css";
import 'react-toastify/dist/ReactToastify.css';

export default function FormRequest() {
    useEffect(() => {
        document.title = "New Request";
    }, []);

    const notify = (type, message) => {
        const properties = {
          position: "top-center",
          transition: Slide,
          autoClose: 1900,
          draggable: true,
          closeOnClick: true,
          pauseOnHover: false,
        }

        if (toast[type]) {
            toast[type](message, properties); // e.g., toast.success("Success message")
        } else {
            toast(message, properties); // Default toast if type is unknown
        }

    } 

    const navigate = useNavigate();

    const [errorRequest, setErrorRequest] = useState({
        type: "",
        message: ""
    });
    const [errorEmailConfirmation, setErrorEmailConfirmation] = useState({
        type: "",
        message: ""
    });
    const [emailConfirmed, setEmailConfirmed] = useState(false);

    const [isPurposeValid, setPurposeValid] = useState(true);
    const filePortraitRef = useRef(null);
    const editorRef = useRef(null);

    const [dataRegionFees, setRegionFees] = useState([]);
    const [dataCategories, setCategories] = useState([]);
    const [dataPurposes, setPurposes] = useState([]);
    
    const [dataRequester, setRequesterData] = useState({
        name_req: "",
        email_req: "",
        phone_req: "",

    });

    const [selectedRegion, setSelectedRegion] = useState("");
    const [provinces, setProvinces] = useState(psgc.getAllProvinces());
    const [selectedProvince, setSelectedProvince] = useState("");
    const [cities, setCities] = useState([]);
    const [selectedCity, setSelectedCity] = useState("");
    const [brgys, setBrgys] = useState([]);
    //const [selectedBrgy, setSelectedBrgy] = useState("");

    useEffect(() => {
        // Reset if no province is selected
        if (!selectedProvince || !selectedProvince.prv_code) {
            setCities([]);
            setBrgys([]);
            return;
        }
    
        // Fetch cities (municipalities) for the selected province
        const municipalities = psgc.getMunicipalitiesByProvince(selectedProvince.prv_code);
        setCities(municipalities);
    
        // Reset city & barangay **only if province changes**
        setBrgys([]);
        setSelectedCity(prevCity => {
            return cities.some(city => city.mun_code === prevCity?.mun_code) ? prevCity : "";
        });
    
        // Fetch barangays **only if selectedCity is valid**
        if (selectedCity && selectedCity.mun_code) {
            const barangays = psgc.getBarangaysByMunicipality(selectedCity.mun_code);
            setBrgys(barangays);
        }
    
    }, [selectedProvince, selectedCity]);


    const [selectedPurposes, setSelectedPurposes] = useState("");
    const [dataOwner, setOwnerData] = useState({});
    const [dataDocument, setDocumentData] = useState({
        selectedDocuments: [
        ],
        total_price: "",
        purpose: "",
        portrait: "",
        desc_req: "",
        // Visayas
        delivery_region: ""
    });

    const [shippingFees, setShippingFees] = useState({
        Luzon: 0,
        Visayas: 0,
        Mindanao: 0,
    });    

    const [showPrivacyModal, setShowPrivacyModal] = useState(true);
    const [showSuccessModal, setShowSuccessModal] = useState(false);    
    const [acceptedPrivacy, setAcceptPrivacy] = useState(false);

    const [referenceNumber, setReferenceNumber] = useState("");
    const [claimMode, setClaimMode] = useState("Pickup");

    const [displayPortrait, setDisplayPortrait] = useState('');
    const [selectedPortrait, setSelectedPortrait] = useState(null);

    const [displayRefNumbers, setDisplayRefNumbers] = useState([]);
    
    const [note, setNote] = useState("");
    const [error, setError] = useState(null);

    const [courses, setCourses] = useState([]);

    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("");

    const [isDeliveryEnabled, setIsDeliveryEnabled] = useState(false);
    useEffect(() => {
        const fetchStatus = () => {
            axios.get("https://docuquest-swu.swucite.tech/api_drts/shippingFee.php?fetch_delivery_status=true")
                .then(response => {
                    //console.log("API Response:", response.data);
                    if (response.data && response.data.delivery_status !== undefined) {
                        // If "mixed", treat as disabled (0)
                        const status = response.data.delivery_status === "mixed" ? 0 : response.data.delivery_status;
                        setIsDeliveryEnabled(status === 1);

                        //console.log("isDeliveryEnabled:", isDeliveryEnabled);
                    }
                })
                .catch(error => {
                    //console.error("Error fetching delivery status:", error);
                });
        };

        fetchStatus();
        const interval = setInterval(fetchStatus, 5000);

        return () => clearInterval(interval); // Cleanup on unmount
    }, []);

    useEffect(() => {
      axios
        .get("https://docuquest-swu.swucite.tech/api_drts/categoryDocs.php")
        .then((response) => {
          //console.log("API Response:", response.data); // Check backend response
          if (Array.isArray(response.data)) {
            const visibleDocs = response.data.filter(
              (doc) => doc.hidden === 0 || doc.hidden === "0"
            );
            //console.log("Filtered Documents:", visibleDocs); // Check filtered docs
            setCategories(visibleDocs);
          }
        })
        .catch((err) =>
          setErrorRequest({
            type: "danger",
            message: `ERROR fetching categories: ${err}`,
          })
        );
    }, []);    

    useEffect(() => {
        const fetchCourses = async () => {
            try {
                const response = await axios.get("https://docuquest-swu.swucite.tech/api_drts/courses.php");
                if (response.data.status === "success") {
                    setCourses(response.data.courses);
                } else {
                    // console.error("Error fetching courses:", response.data.message);
                }
            } catch (error) {
                // console.error("Error fetching courses:", error);
            }
        };
    
        // Fetch the note from the backend
        const fetchNote = async () => {
            try {
                const response = await axios.get("https://docuquest-swu.swucite.tech/api_drts/note.php");
                if (response.data.status === "success") {
                    setNote(response.data.note);
                } else {
                    setError("Failed to fetch the note from the database.");
                }
            } catch (error) {
                //console.error("Error fetching the note:", error);
                setError("Error fetching the note. Please check the console for details.");
            }
        };

        fetchCourses();
        fetchNote();


        // Fetch document categories
        axios
            .get("https://docuquest-swu.swucite.tech/api_drts/categoryDocs.php")
            .then((response) => {
                // if (Array.isArray(response.data)) {
                //     // Exclude hidden documents
                //     const visibleDocs = response.data.filter(doc => doc.hidden === 0 || doc.hidden === "0");
                //     setCategories(visibleDocs);
                // }

                setCategories(response.data);
            })
            .catch((err) =>
                setErrorRequest({ type: "danger", message: `ERROR fetching categories: ${err}` })
            );

        // Fetch request purposes
        axios
            .get("https://docuquest-swu.swucite.tech/api_drts/purposes.php")
            .then((response) => setPurposes(response.data))
            .catch((err) => setErrorRequest({type: "danger", message: `ERROR fetching purposes: ${err}`}));

        // Fetch regions and fees
        axios.get('https://docuquest-swu.swucite.tech/api_drts/shippingFee.php')
            .then((response) => {
                setShippingFees(response.data); // Set the updated shipping fees
                //console.warn("shipping fees ", shippingFees)
            })
            .catch((error) => {
                // setErrorFees({
                //     type: "danger",
                //     message: `Error fetching updated shipping fees: ${error.response ? error.response.data : error.message}`
                // });
            });

        // Fetch logged in user info
        // const endpoint = sessionStorage.getItem("role_user")
        //     ? `https://docuquest-swu.swucite.tech/api_drts/users.php/${loggedId}/`
        //     : `https://docuquest-swu.swucite.tech/api_drts/clients.php/${loggedId}/`;

        // axios.get(endpoint)
        //     .then((res) => {
        //         const user = res.data;

        //         setRequesterData({
        //             name_req: user.name || "",
        //             email_req: user.email || "",
        //             phone_req: user.phone || "",
        //         });
        //     })
        //     .catch((err) => {
        //         setErrorRequest({type: "danger", message: `ERROR fetching data: ${err}`});
        //     });
    
        // Check sessionStorage to see if the privacy policy was already accepted    
        const isPrivacyAccepted = sessionStorage.getItem("privacyAccepted") === "true";
        setShowPrivacyModal(!isPrivacyAccepted);
    }, []);
    
    useEffect(() => {
        if (claimMode === "Delivery" && !selectedRegion) {
            setSelectedRegion("Visayas");
        }
    }, [claimMode, selectedRegion]);

    const handlePhoneInputChange = (e, setState, targetAttribute) => {
        let { name, value } = e.target;
    
        // Allow only numeric values
        value = value.replace(/[^0-9+-]/g, "");

        // Ensure max length per part
        if (name.endsWith("part1")) {
            value = value.slice(0, 4);
        } else if (name.endsWith("part2")) {
            value = value.slice(0, 3);
        } else if (name.endsWith("part3")) {
            value = value.slice(0, 4);
        }
    
        // Update state
        setState((prevData) => {
            const updatedData = {
                ...prevData,
                [name]: value, // Store individual part
            };
    
            // Combine all parts when filled
            if (
                updatedData[`${targetAttribute}_part1`]?.length === 4 &&
                updatedData[`${targetAttribute}_part2`]?.length === 3 &&
                updatedData[`${targetAttribute}_part3`]?.length === 4
            ) {
                updatedData[targetAttribute] = `${updatedData[`${targetAttribute}_part1`]}-${updatedData[`${targetAttribute}_part2`]}-${updatedData[`${targetAttribute}_part3`]}`;
            } else {
                updatedData[targetAttribute] = ""; // Reset if incomplete
            }
    
            //console.log(`Updated ${targetAttribute}:`, updatedData[targetAttribute]); // Debugging
    
            return updatedData;
        });

        // Auto-focus FORWARD when full
        if (name.endsWith("part1") && value.length === 4) {
            document.querySelector(`input[name="${targetAttribute}_part2"]`)?.focus();
        } else if (name.endsWith("part2") && value.length === 3) {
            document.querySelector(`input[name="${targetAttribute}_part3"]`)?.focus();
        }

        // Auto-focus BACKWARD when empty
        if (name.endsWith("part3") && value.length === 0) {
            document.querySelector(`input[name="${targetAttribute}_part2"]`)?.focus();
        } else if (name.endsWith("part2") && value.length === 0) {
            document.querySelector(`input[name="${targetAttribute}_part1"]`)?.focus();
        }
    };
    
    const handleStreetInputChange = (e, setState, targetAttribute) => {
        const { name, value } = e.target;
    
        // Update state
        setState((prevData) => {
            const updatedData = {
                ...prevData,
                [name]: value, // Store the current field
            };
    
            // Combine both parts when filled
            if (updatedData.street_part1 && updatedData.street_part2) {
                updatedData[targetAttribute] = `${updatedData.street_part1}, ${updatedData.street_part2}`;
            } else {
                updatedData[targetAttribute] = ""; // Reset if incomplete
            }
    
            // console.log(`Updated ${targetAttribute}:`, updatedData[targetAttribute]); // Debugging
    
            return updatedData;
        });
    };
    
    // const handleInputChange = (e, setState) => {
    //     const { name, value } = e.target;
    //     //console.warn(`${name} : ${value}`);

    //     setState((prevData) => ({ ...prevData, [name]: value }));
    // };

    const handleInputChange = (e, setState, index = null) => {
        const { name, value } = e.target;
    
        setState((prevData) => {
          if (index !== null) {
            // If modifying a field inside selectedDocuments
            const updatedDocs = [...prevData.selectedDocuments];
            updatedDocs[index] = { ...updatedDocs[index], [name]: value };
    
            return { ...prevData, selectedDocuments: updatedDocs };
          } else {
            // For top-level updates
            return { ...prevData, [name]: value };
          }
        });
    };

    const setDocumentPrice = () => {
        setDocumentData((prevState) => {
            const updatedSelectedDocuments = prevState.selectedDocuments.map((doc) => {
                // Multiply quantity and price for each document
                const totalPriceForDocument = parseInt(doc.quantity, 10) * parseInt(doc.price, 10);
                return { ...doc, calculatedPrice: totalPriceForDocument }; // Add new attribute `calculatedPrice` to each document
            });
    
            // Calculate the overall total price
            const total_price = updatedSelectedDocuments.reduce((acc, doc) => acc + doc.totalPrice, 0);
    
            return {
                ...prevState,
                selectedDocuments: updatedSelectedDocuments, // Update documents with individual totals
                total_price: total_price // Update the overall total price
            };
        });       
    }

    const setTotalPrice = (newPrice) => {
        var newPrice = parseInt(newPrice, 10);

        setDocumentData(prevState => ({
            ...prevState, // Spread the previous state to preserve selectedDocuments
            total_price: (parseInt(...prevState.total_price, 10) || 0) + newPrice // Update the total_price
        }));
    }

    const handleDocumentChange = (e, categoryId) => {
        const { name, value } = e.target;
        const category = dataCategories.find(cat => cat.id === categoryId);

        // If document is multi-purpose, ignore any quantity changes
        if (category.multi_purpose == 1) {
            return;
        }

        setDocumentData((prevData) => {
            const updatedDocuments = prevData.selectedDocuments.map((doc) =>
              doc.document === category.name
                ? { ...doc, quantity: parseInt(value, 10) || 1 }
                : doc
            );
            return { ...prevData, selectedDocuments: updatedDocuments };
          });
    }

    const handleCheckboxRegion = (e) => {
        const { value } = e.target;
        //console.warn("selected region", value);

        setSelectedRegion(value);

        handleInputChange(e, setDocumentData)
    }

    const handleCheckboxPurpose = (e) => {
        const { checked, value } = e.target;

        const isMultiPurposeAllowed = dataDocument.selectedDocuments.some((doc) => {
            const category = dataCategories.find(
                (cat) => cat.name.trim().toLowerCase() === doc.document.trim().toLowerCase()
            );
            return category?.multi_purpose == 1;
        });

        let newSelectedPurposes;

        if (!isMultiPurposeAllowed) {
            // If multi-purpose is NOT allowed, allow only ONE purpose, but also allow unchecking
            newSelectedPurposes = selectedPurposes.includes(value) ? [] : [value];
        } else {
            newSelectedPurposes = checked
                ? [...selectedPurposes, value] // Add to the array
                : selectedPurposes.filter((purpose) => purpose !== value); // Remove if unchecked
        }

        setSelectedPurposes(newSelectedPurposes);

        setDocumentData((prevData) => {
            // Update quantity for multi-purpose documents based on number of selected purposes
            const updatedDocuments = prevData.selectedDocuments.map((doc) => {
                const category = dataCategories.find(
                    (cat) => cat.name.trim().toLowerCase() === doc.document.trim().toLowerCase()
                );
                
                if (category?.multi_purpose == 1) {
                    return {
                        ...doc,
                        quantity: newSelectedPurposes.length || 1
                    };
                }
                return doc;
            });
    
            return {
                ...prevData,
                selectedDocuments: updatedDocuments,
                purpose: newSelectedPurposes,
            };
        }); 
    }

    const handleCheckboxDocument = (e, category) => {
        const { checked, value } = e.target;

        setDocumentData((prevData) => {
            const selectedDocuments = checked
                ? [
                    ...prevData.selectedDocuments,
                    { document_id: category.id,
                      document: value, 
                      quantity: 1, 
                      price: category.price,
                      isMultiPurpose: category.multi_purpose == 1
                      
                    },
                ]
                : prevData.selectedDocuments.filter((doc) => doc.document !== value);
            return { ...prevData, selectedDocuments };
        });
    };

    const handlePortraitChange = (e) => {
        const file = e.target.files[0];
        const allowedTypes = ["image/jpeg", "image/png"];

        const MAX_FILE_SIZE_MB = 20; // 20MB Limit
        const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024; // Convert to Bytes

        if (!file) {
          notify("warning", `WARNING: 2x2 portrait is not set!`);
          return;
        }
        
        if (file && !allowedTypes.includes(file.type)) {
          notify("error", `ERROR: ${file.name} is not a JPG or PNG image file!`);
          setSelectedPortrait(null);
          return;
        }

        if (file.size > MAX_FILE_SIZE_BYTES) {
          notify("error", `ERROR: ${file.name} is too large. Image can only be 20MB or below.`);
          setSelectedPortrait(null);
          return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            const result = reader.result;

            // if (result.startsWith("data:image/jpeg") || reader.result.startsWith("data:image/png")) {
            //     setDisplayPortrait(result);
            //     setSelectedPortrait(result);
            // } else {
            //     notify("error", "Unsupported image format. Please upload JPG or PNG.");
            // }

            if (result.startsWith("data:image/png")) {
                // Check transparency for PNG
                const img = new Image();
                img.onload = () => {
                    const canvas = document.createElement("canvas");
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0);
    
                    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    
                    let hasTransparency = false;
                    for (let i = 0; i < imageData.length; i += 4) {
                        const alpha = imageData[i + 3];
                        if (alpha < 255) {
                            hasTransparency = true;
                            break;
                        }
                    }
    
                    if (hasTransparency) {
                        notify("error", "ERROR: PNG image contains transparency, which is not allowed.");
                        setDisplayPortrait('');
                        setSelectedPortrait(null);
                        if (filePortraitRef.current) filePortraitRef.current.value = "";
                        return;
                    } else {
                        setDisplayPortrait(result);
                        setSelectedPortrait(result);
                    }
                };
                img.onerror = () => {
                    notify("error", "ERROR: Failed to load image for transparency check.");
                };
                img.src = result;
    
            } else {
                // For JPEG or non-transparent PNG
                setDisplayPortrait(result);
                setSelectedPortrait(result);
            }
        };
        reader.readAsDataURL(file);
    };

    const handleSupportDocsChange = (e) => {
        const files = Array.from(e.target.files);
      
        if (!files) {
            notify("warning", `WARNING: Supporting docs is not provided!`);
            return;
        }

        // only 3 files allowed (not working due to LONGTEXT limits in mysql)
        // files.length > 1
        if (files.length > 1) {
            notify("error", "You can only upload a maximum of 1 PDF file.");
            e.target.value = ""; // Clear the file input
            setDocumentData(prev => ({ ...prev, supporting_docs: "" }));
            return;
         }

        // confirm that all files are pdf
        if (files.some(file => file.type !== "application/pdf")) {
          notify("error", "Only PDF files are allowed!");
          e.target.value = "";
          setDocumentData(prev => ({ ...prev, supporting_docs: "" }));
          return;
        }
      
        // Convert all pdfs to base64
        Promise.all(
          files.map(file => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => resolve(reader.result); // base64 string
            reader.onerror = reject;
            reader.readAsDataURL(file);
          }))
        )
        .then(base64Strings => {
          // Convert to a JSON-style stringified array with comma-separated values
          const formattedString = `[${base64Strings.map(s => `"${s}"`).join(",")}]`;
      
          setDocumentData(prev => ({
            ...prev,
            supporting_docs: formattedString
          }));
        })
        .catch(() => {
          notify("error", "Failed to read one or more PDF files.");
          setDocumentData(prev => ({ ...prev, supporting_docs: "[]" }));
        });
    };

    useEffect(() => {
        //console.warn("new displayPortrait:", displayPortrait)
    }, [displayPortrait])

    const handleFormSubmit = (e) => {
        e.preventDefault();

        if (selectedPurposes.length === 0) {
            setErrorRequest({ type: "danger", message: "Please select a purpose for the request." });
            return;
        }
        
        if (dataDocument.selectedDocuments.length === 0) {
            setErrorRequest({ type: "danger", message: "Please select at least one document." });
            return;
        }

        // for each selected document, get product of quantity and price
        // add a new attribute "totalPrice" to each item in dataDocument.selectedDocuments
        const updatedSelectedDocuments = dataDocument.selectedDocuments.map((doc) => {
            let totalPrice;
            
            if (doc.isMultiPurpose) {
              // For multi-purpose docs: price * number of purposes
              totalPrice = parseInt(doc.price, 10) * selectedPurposes.length;
            } else {
              // For regular docs: price * quantity
              totalPrice = parseInt(doc.quantity, 10) * parseInt(doc.price, 10);
            }
        
            return { 
              ...doc,
              totalPrice,
              totalPurpose: selectedPurposes.length,
            //   calculatedPrice: totalPrice
            };
        });
    
        // Calculate base total from documents
        let final_total = updatedSelectedDocuments.reduce(
            (acc, doc) => acc + doc.totalPrice, 0
        );

        if (claimMode === "Delivery") {
            //console.warn("selected region: ", selectedRegion);
            // TODO map shipping fees with loop and output case
            switch (selectedRegion){

                case 'Luzon':
                    final_total += parseInt(shippingFees[0].fee, 10);
                    break;
                case 'Visayas':
                    final_total += parseInt(shippingFees[1].fee, 10);
                    break;
                case 'Mindanao':
                    final_total += parseInt(shippingFees[2].fee, 10);
                    break;    
            }

        }

        const purposeCount = selectedPurposes.length;

        // TODO include description
        setDocumentData((prevState) => ({
            ...prevState,
            selectedDocuments: updatedSelectedDocuments,
            total_price: final_total,
            purpose: selectedPurposes,
            purposeCount: purposeCount 
        }));

        const localRefNumbers = [];
        const generatedRefNumber = `REF-${Date.now()}-${Math.floor(100000 + Math.random() * 900000)}`;
        setReferenceNumber(generatedRefNumber) // Only one reference number for all selected documents



        const postRequests = dataDocument.selectedDocuments.map((document) => {
            // localRefNumbers.push(referenceNumber);
            // setDisplayRefNumbers((prev) => [...prev, generatedRefNumber]);
            
            const completeData = {
                ...dataRequester,
                ...dataOwner,
                desc_req: dataDocument.desc_req, 
                selectedDocuments: updatedSelectedDocuments,
                total_price: final_total,
                currentDocId: document.document_id,
                currentDocument: document.document,
                currentQuantity: document.quantity.toString(),
                currentPrice: document.price.toString(),
                reference_number: generatedRefNumber,
                file_portrait: selectedPortrait,
                service_type: claimMode,
                delivery_region: selectedRegion,
                payment_method: selectedPaymentMethod,
                purpose: selectedPurposes,
                purposeCount: purposeCount,
                file_portrait: displayPortrait,
                supporting_docs: dataDocument.supporting_docs
            };

            // console.warn("profile picture submitted: ", selectedPortrait);
            // console.warn("You submitted: ", completeData)

            return (
                axios
                .post("https://docuquest-swu.swucite.tech/api_drts/transactions.php", completeData, {
                    headers: { "Content-Type": "application/json" },
                    maxContentLength: Infinity,
                    maxBodyLength: Infinity
                })
                .then((res) => {
                    // console.warn("POST insert response: ", res.data)
                    setErrorRequest({type: "success", message: `Request ${generatedRefNumber} submitted successfully: ${res.data.message}`})
                    setErrorEmailConfirmation({type: "success", message: res.data.message || "Submitting request..."})
                    //console.warn(`Request ${generatedRefNumber} submitted successfully: ${res.data.message}`);
                })
                .catch((err) => {
                    setErrorRequest({type: "danger", message: `Error submitting request ${document.name}: ${err}`})
                    //console.error(`Error submitting request ${document.name}: ${err}`)
                })
            );

        });

        // Wait for all requests to finish
        Promise.all(postRequests)
        .then(() => {
            setErrorRequest({type: "info", message: `Submitting request...`});
            setErrorEmailConfirmation({type: "info", message: `Submitting request...`});
            setShowSuccessModal(true);

            // console.warn("ref number ", generatedRefNumber);
            // console.warn("requestor email ", dataRequester.email_req);
            // console.warn("requestor name ", dataRequester.name_req);
            
            // send email to requestor
            axios
            .post("https://docuquest-swu.swucite.tech/api_drts/confirmRequest.php", {
                reference: generatedRefNumber,
                email_req: dataRequester.email_req,
                name_req: dataRequester.name_req
            })
            .then((res) => {
                setErrorEmailConfirmation({type: "success", message: `Request confirmed! Please monitor your email for further updates.`});
                setEmailConfirmed(true);
            })
            .catch((err) => {
                setErrorRequest({type: "danger", message: `Error submitting requests ${displayRefNumbers}: ${err}`})
                //console.error(`Error submitting requests ${displayRefNumbers}: ${err}`)
            })
        })
        .catch((err) => {
            setErrorRequest({type: "danger", message: `Error in submitting documents: ${err}`})
        });
    };

    const handlePrivacyAccept = () => {
        sessionStorage.setItem("privacyAccepted", "true");
        setShowPrivacyModal(false);
    };

    const handleCloseSuccessModal = () => {
        setShowSuccessModal(false);
        navigate(`/start`);
        // navigate(`/tracking/${referenceNumber}`);
    };

    return (
        <div className="form-request-wrapper">
            <div className="form-request-container">
                {/* Data Privacy Modal */}
                {/* backdrop={true} */}
                <Modal centered show={showPrivacyModal} onHide={() => setShowPrivacyModal(false)} backdrop="static">
                    {/* closeButton */}
                    <Modal.Header >
                        <Modal.Title>Data Privacy Notice</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                    <section className="info-long">
                    <p>The data you provide will be used
                    solely for processing your request and for purposes related to the research study, 
                    SWU Registrar DocuQuest: A Document Request and Tracking System.</p>
                    
                    <p>Your information will remain strictly confidential and will be handled
                    in compliance with the <a href="https://privacy.gov.ph/data-privacy-act/" title="REPUBLIC ACT 10173 DATA PRIVACY ACT OF 2012" target="_blank" rel="noopener noreferrer"> Data Privacy Act of 2012 (Republic Act No. 10173)</a>.
                    This law ensures the protection of your personal data and grants you rights as a participant,
                    including the right to access, correct, or withdraw your data at any time.</p>
                    
                    <p>Rest assured, your information will not be shared with third parties
                    without your explicit consent, except as required by law.</p>

                    <p>By filling out this document request form, you confirm that you
                    have been informed of these terms and agree to the processing of your data for the specified purposes.</p>
                    
                    <p>Should you have any concerns or require further clarification, 
                    please feel free to contact us directly.</p>
                    </section>
                        <Form.Group className="mt-3">
                            <Form.Check 
                                type="checkbox"
                                id="privacyCheckbox"
                                label="By checking this box, I confirm I have read and accept the Data Privacy Policy."
                                title="I accept the terms outlined in the Data Privacy Policy."
                                checked={acceptedPrivacy}
                                onChange={(e) => setAcceptPrivacy(e.target.checked)}
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button disabled={!acceptedPrivacy} title={!acceptedPrivacy ? "Click on the checkbox to proceed." : ""} onClick={handlePrivacyAccept} variant="outline-primary">I Accept</Button>
                    </Modal.Footer>
                </Modal>

                <div className="back-section">
                    <Button variant="dark" onClick={() => navigate(-1)} title="Go back to landing page.">
                        Go Back
                    </Button>
                </div>

                <div className="form-section">
                    <div className='title-wrapper'>
                      <h2 id="header-form-request">Document&nbsp;Request&nbsp;Form</h2>                        
                      <p className="instructions"><span className="required" >*</span> — required fields</p>
                      <p className="instructions">Please answer all fields that apply.</p>
                    </div>
                </div>
                {errorRequest && (
                <Alert variant={errorRequest.type}>
                    {errorRequest.message}
                </Alert>
                )}

                {/* <Form onSubmit={handleFormSubmit} >

                </Form> */}
                <div className="form-section">
                    <h3 className="head">Requestor Information</h3>
                    <Form className="form-vertical">
                        <article className="form-content">
                        <Form.Group>
                          <div className="label-wrapper">
                            <Form.Label className="request"><span className="required" >*</span>&nbsp;Requestor's Name</Form.Label>
                            <p className='subtxt'><em>(Format:&nbsp;&nbsp;Lastname,&nbsp;Firstname&nbsp;Middlename)</em></p>
                            <Form.Control
                                required
                                // value={dataRequester.name_req}
                                type="text"
                                name="name_req"
                                minLength="3"
                                pattern="^[A-Za-z-]+, [A-Za-z]+( [A-Za-z]+)?$"
                                onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ,\-]/g, '')}
                                onChange={(e) => handleInputChange(e, setRequesterData)}  
                                placeholder="Enter requestor's full name (e.g., Doe, John Test)"
                                title="Please enter a valid full name (e.g., Doe, John Test)"
                            />                            
                          </div>
                        </Form.Group>
                        <Form.Group>
                        <div className="label-wrapper">
                            <Form.Label className="request"><span className="required">*</span>&nbsp;Requestor's Phone</Form.Label>
                            <div style={{ display: "flex", gap: "5px" }}>
                            {/* First 4 digits */}
                            <Form.Control
                                required
                                type="text"
                                name="phone_req_part1"
                                maxLength="4"
                                pattern="^[0-9]+$"
                                onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')} 
                                onChange={(e) => handlePhoneInputChange(e, setRequesterData, "phone_req")}
                                placeholder="XXXX"
                            />
                            {/* Middle 3 digits */}
                            <Form.Control
                                required
                                type="text"
                                name="phone_req_part2"
                                maxLength="3"
                                pattern="^[0-9]+$"onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')} 
                                onChange={(e) => handlePhoneInputChange(e, setRequesterData, "phone_req")}
                                placeholder="XXX"
                            />
                            {/* Last 4 digits */}
                            <Form.Control
                                required
                                type="text"
                                name="phone_req_part3"
                                maxLength="4"
                                pattern="^[0-9]+$"
                                onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')} 
                                onChange={(e) => handlePhoneInputChange(e, setRequesterData, "phone_req")}
                                placeholder="XXXX"
                            />
                            </div>
                        </div>
                        </Form.Group>

                        <Form.Group>
                          <div className="label-wrapper">
                            <Form.Label className="request"><span className="required" >*</span>&nbsp;Requestor's Email</Form.Label>
                            <Form.Control
                                required
                                // readOnly
                                // value={dataRequester.email_req}
                                type="email"
                                name="email_req"
                                minLength="1"
                                onChange={(e) => handleInputChange(e, setRequesterData)}
                                placeholder="Enter requestor's email address"
                            />    
                          </div>
                        </Form.Group>
                        </article>
                    </Form>
                </div>

                <div className="form-section">
                    <h3 className="head">Document Owner Information</h3>
                    <Form className="form-vertical">
                    
                        <article className="form-content">
                        <Form.Group>
                          <div className="label-wrapper">
                            <Form.Label className="request"><span className="required" >*</span>&nbsp;Family Name</Form.Label>
                            <Form.Control
                                required
                                type="text"
                                name="name_last"
                                onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
                                onChange={(e) => handleInputChange(e, setOwnerData)}
                                placeholder="Enter last name"
                            />
                          </div>
                        </Form.Group>

                        <Form.Group>
                          <div className="label-wrapper">
                            <Form.Label className="request"><span className="required" >*</span>&nbsp;First Name</Form.Label>
                            <Form.Control
                                required
                                type="text"
                                name="name_first"
                                onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
                                onChange={(e) => handleInputChange(e, setOwnerData)}
                                placeholder="Enter first name"
                            />
                          </div>
                        </Form.Group>

                        <Form.Group>
                          <div className="label-wrapper">
                            <Form.Label className="request">Middle Name</Form.Label>
                            <p className='subtxt'><em>(Leave blank if no&nbsp;middle&nbsp;name.)</em></p>
                            <Form.Control
                                type="text"
                                name="name_middle"
                                onInput={(e) => e.target.value = e.target.value.replace(/[^A-Za-z ]/g, '')}
                                onChange={(e) => handleInputChange(e, setOwnerData)}
                                placeholder="Enter middle name"
                            />
                          </div>
                        </Form.Group>

                        <Form.Group>
                        <div className="label-wrapper">
                            <Form.Label className="request"><span className="required">*</span>&nbsp;Owner's Phone</Form.Label>
                            <div style={{ display: "flex", gap: "5px" }}>
                            {/* First 4 digits */}
                            <Form.Control
                                required
                                type="text"
                                name="phone_owner_part1"
                                maxLength="4"
                                pattern="^[0-9]+$"
                                onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')} 
                                onChange={(e) => handlePhoneInputChange(e, setOwnerData, "phone_owner")}
                                placeholder="XXXX"
                            />
                            {/* Middle 3 digits */}
                            <Form.Control
                                required
                                type="text"
                                name="phone_owner_part2"
                                maxLength="3"
                                pattern="^[0-9]+$"
                                onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')} 
                                onChange={(e) => handlePhoneInputChange(e, setOwnerData, "phone_owner")}
                                placeholder="XXX"
                            />
                            {/* Last 4 digits */}
                            <Form.Control
                                required
                                type="text"
                                name="phone_owner_part3"
                                maxLength="4"
                                pattern="^[0-9]+$"
                                onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')} 
                                onChange={(e) => handlePhoneInputChange(e, setOwnerData, "phone_owner")}
                                placeholder="XXXX"
                            />
                            </div>
                        </div>
                        </Form.Group>

                        <Form.Group>
                        <div className="label-wrapper">
                            <Form.Label className="request">
                            <span className="required">*</span>&nbsp;Course
                            </Form.Label>
                            <Form.Control
                            required
                            as="select"
                            name="course"
                            onChange={(e) => {
                                const value = e.target.value.toUpperCase();
                                handleInputChange({ target: { name: e.target.name, value } }, setOwnerData);
                            }}
                            >
                            <option value="">Select a course</option>
                            {courses.map((course) => (
                                <option key={course.id} value={course.course_name}>
                                {course.course_name}
                                </option>
                            ))}
                            </Form.Control>
                        </div>
                        </Form.Group>

                        <Form.Group>
                          <div className="label-wrapper">
                            <Form.Label className="request">Student ID</Form.Label>
                            <p className='subtxt'><em>(Leave blank if not&nbsp;an active student at&nbsp;SWU-PHINMA.)</em></p>
                            <Form.Control
                                type="tel"
                                name="id_swu"
                                maxLength="20"
                                pattern="[0-9]{2}-[0-9]{4}-[0-9]{5}"
                                onInput={(e) => e.target.value = e.target.value.replace(/[^0-9-]/g, '')}
                                onChange={(e) => handleInputChange(e, setOwnerData)}
                                placeholder="XX-XXXX-XXXXX"
                            />
                          </div>
                        </Form.Group>

                        {/* TODO compare last year at swu and year course taken. last year at SWU should be greater than or equal to year enrolled */}
                        <Form.Group>
                          <div className="label-wrapper">
                            <Form.Label className="request"><span className="required" >*</span>&nbsp;Year Course Taken</Form.Label>
                            <Form.Control
                                required
                                type="text"
                                name="course_year"
                                onChange={(e) => handleInputChange(e, setOwnerData)}
                                placeholder="Enter year course was first enrolled (e.g., 2021)"
                                title="Please enter a valid 4-digit year (e.g., 2021)"
                                pattern="^[1-9][0-9]{3}$"
                                onInput={(e) => {
                                  e.target.value = e.target.value.replace(/\D/g, "").slice(0, 4); // Removes non-digits and trims to 4 characters
                                }}
                            />
                          </div>
                        </Form.Group>

                        <Form.Group>
                          <div className="label-wrapper">
                            <Form.Label className="request"><span className="required" >*</span>&nbsp;Last&nbsp;Year&nbsp;at&nbsp;SWU</Form.Label>
                            <Form.Control
                                required
                                type="text"
                                name="year_last"
                                onChange={(e) => handleInputChange(e, setOwnerData)}
                                placeholder="Enter last year officially enrolled at SWU (e.g., 2025)"
                                title="Please enter a valid 4-digit year (e.g., 2024)"
                                pattern="^[1-9][0-9]{3}$"
                                onInput={(e) => {
                                  e.target.value = e.target.value.replace(/\D/g, "").slice(0, 4); // Removes non-digits and trims to 4 characters
                                }}
                            />
                          </div>
                        </Form.Group>
                        </article>
                    </Form>
                </div>

                <div className="form-section">
                    <div className='title-wrapper'>
                      <h3 className="head">Document&nbsp;Request&nbsp;Details</h3>
                      <p className="instructions">Please select at least <span className="required" >one (1)</span> document. at least <span className="required" >one (1)</span> purpose.</p>
                      <p className="instructions">If the <span className="required" >selected document allows multiple purposes</span>, <br/>then you are allowed to select <span className="required" >select multiple purposes</span>.</p>
                    </div>
                    
                    <Form className="form-vertical">
                        <article className="form-content">

   
                        <Form.Group>
                        {/* style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} */}
                            <Form.Group >
                            <section className="center-form">

                            <Form.Label className="request"><span className="required" >*</span>&nbsp;Select all documents to request</Form.Label>
                            <table className="table-select-document">
                            <caption>
                                <p className="additional-info" style={{ fontSize: '14px', color: '#555' }}>
                                    <strong>Note:</strong>&nbsp;{error ? "Default note: Additional charges may apply." : note || "No note available."}
                                </p>
                            </caption>
                              <thead>
                              {dataCategories.length > 0 && (
                                <tr>
                                  <th>Action</th>
                                  <th>Type</th>
                                  <th>Processing&#32;(working&nbsp;days)</th>
                                  <th>Number of Pages</th>
                                  <th>Price&nbsp;(₱)</th>
                                  <th>No. of Copies</th>
                                  <th>Multiple Purpose</th>
                                </tr>
                              )}
                              </thead>
                              <tbody>
                              {/* TODO checkbox without label */}
                              {dataCategories.length > 0 ? (
                                dataCategories.map((category, index) => (
                                <tr key={index}>
                                    <td className="type">
                                    <Form.Check
                                        type="checkbox"
                                        aria-label={`select document ${category.name}`}
                                        value={category.name}
                                        onChange={(e) => handleCheckboxDocument(e, category)}
                                        style={{ marginRight: '10px' }}
                                    />    
                                    </td>
                                    <td>{category.name}</td>
                                    <td>{category.processing_days}</td>
                                    <td>{category.pages}</td>
                                    <td>{`₱${category.price}`}</td>
                                    <td>
                                    {dataDocument.selectedDocuments.find(
                                        (doc) => doc.document === category.name
                                    ) && (
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                        {category.multi_purpose == 1 ? (
                                            // For multi-purpose documents - fixed quantity
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <Form.Control
                                                required
                                                type="number"
                                                min="1"
                                                value={selectedPurposes.length || 1}
                                                readOnly
                                                style={{ 
                                                width: "80px", 
                                                marginRight: "20px",
                                                backgroundColor: '#f8f9fa',
                                                cursor: 'not-allowed'
                                                }}
                                                title="Multi-purpose documents are automatically calculated based on purposes selected"
                                            />
                                            <span style={{ fontSize: '0.8em', color: '#666' }}>
                                                (Auto: {selectedPurposes.length || 0} purpose{selectedPurposes.length !== 1 ? 's' : ''})
                                            </span>
                                            </div>
                                        ) : (
                                            // For single-purpose documents - editable quantity
                                            <Form.Control
                                            required
                                            type="number"
                                            min="1"
                                            value={
                                                dataDocument.selectedDocuments.find(d => d.document === category.name)?.quantity || 1
                                            }
                                            onChange={(e) => {
                                                const newQuantity = parseInt(e.target.value, 10) || 1;
                                                setDocumentData(prevData => ({
                                                ...prevData,
                                                selectedDocuments: prevData.selectedDocuments.map(doc => 
                                                    doc.document === category.name 
                                                    ? { ...doc, quantity: newQuantity }
                                                    : doc
                                                )
                                                }));
                                            }}
                                            style={{ width: "80px" }}
                                            />
                                        )}
                                        </div>
                                    )}
                                    </td>
                                    <td>
                                        {category.multi_purpose === 1 ? "Yes" : "No"}{" "} {/* Display multi-purpose status */}
                                    </td>
                                </tr>
                                ))
                              ) : (
                                <tr>
                                   <td colSpan="4">No data available</td>
                                </tr>
                              )}
                              </tbody>
                            </table>

                            </section>
                            </Form.Group>
                        </Form.Group>
                        <Form.Group>
                            <section className="center-form">
                            <Form.Label className="request"><span className="required" >*</span>&nbsp;Purpose</Form.Label>

                            <table className="table-select-purpose">
                              <thead>
                              {dataPurposes.length > 0 && (
                                <tr>
                                 <th>Action</th>
                                 <th>Purpose</th>
                                </tr>
                              )}
                              </thead>
                              <tbody>
                              {dataPurposes.length > 0 ? (
                                dataPurposes.map((purpose, index) => (
                                <tr key={index}>
                                 <td className="action">
                                 <Form.Check
                                    key={purpose.id}
                                    type="checkbox"
                                    // radio-
                                    id={`checkbox-${purpose.name_purpose}`}
                                    name="purpose_req"
                                    value={purpose.name_purpose}
                                    checked={selectedPurposes.includes(purpose.name_purpose)}
                                    onChange={handleCheckboxPurpose}
                                    style={{
                                        display: "inline-block",
                                        marginRight: "10px",
                                    }}
                                    disabled={
                                        dataDocument.selectedDocuments.length === 0 || 
                                        (
                                            !dataDocument.selectedDocuments.some((doc) => {
                                                const category = dataCategories.find(
                                                    (cat) => cat.name.trim().toLowerCase() === doc.document.trim().toLowerCase()
                                                );
                                                return category?.multi_purpose == 1;
                                            }) && selectedPurposes.length > 0 // Disable only if a purpose is already selected
                                        ) && !selectedPurposes.includes(purpose.name_purpose) // Allow unchecking the selected one
                                    }
                                    // custom-radio-
                                    className="custom-checkbox"
                                  />    
                                 </td>
                                 <td>{purpose.name_purpose}</td>
                                </tr>   
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="2">No data available</td>
                                </tr>
                              )
                                
                              }
                              </tbody>
                            </table>
                            </section>
                        </Form.Group>
                        {selectedPurposes.includes("Others") ? (
                        <>
                            <Form.Group>
                                <div className="label-wrapper">
                                <Form.Label className="request"><span className="required" >*</span>&nbsp;Description</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    required
                                    rows={3}
                                    name="desc_req"
                                    className="desc_req"
                                    value={dataDocument.desc_req || ""}
                                    onChange={(e) => handleInputChange(e, setDocumentData)}
                                    placeholder="Additional details..."
                                />
                                </div>
                            </Form.Group>
                            <Form.Group controlId="file_supporting_docs">
                                <div className="label-wrapper">
                                    <Form.Label className="request">Supporting Documents</Form.Label>
                                    <p className='subtxt'><em>(Upload the format of the Document you want to achieve)</em></p>
                                    <p className='subtxt'><strong>Allowed file types:</strong>&nbsp;.pdf&nbsp;files <strong>only</strong>.</p>
                                    <Form.Control
                                    type="file"
                                    name="file_supporting_docs"
                                    accept=".pdf"
                                    // multiple
                                    onChange={handleSupportDocsChange}
                                    />
                                </div>
                            </Form.Group>
                        </>
                        ) : (
                            ""
                        )
                        }
                        <Form.Group>
                          <div className="label-wrapper">
                          <Form.Label className="request"><span className="required" >*</span>&nbsp;Service Type</Form.Label>
                          <ToggleButtonGroup
                            type="radio"
                            required 
                            name="service_type"
                            value={claimMode}
                            onChange={(val) => setClaimMode(val)}
                            // onChange={(e) => handleInputChange(e, setClaimMode)}
                            >
                              <ToggleButton id="tbg-radio-1" variant="outline-dark" value="Pickup" title="Pick up the document yourself at the registrar.">
                                Self-Pickup
                              </ToggleButton>
                              <ToggleButton disabled={!isDeliveryEnabled} id="tbg-radio-2" variant="outline-dark" value="Delivery" title="Document is delivered to you at an additional cost.">
                                {isDeliveryEnabled ? "Delivery" : "Delivery Disabled"}
                              </ToggleButton>
                          </ToggleButtonGroup> 
                          </div>
                        </Form.Group>
                        {claimMode === "Delivery" ? ( 
                            <div>  
                                {shippingFees.map((item) => (
                                <Form.Check
                                  inline
                                  required
                                  type="radio"
                                  name="delivery_region"
                                  label={`${item.region} - ₱${item.fee}`}
                                  value={item.region}
                                  onChange={handleCheckboxRegion}
                                  checked={dataDocument.delivery_region === item.region}
                                />      
                                ))}
                                <div className='title-wrapper'>
                                <p><span className="required" >*</span>&nbsp;Select a region where to deliver the document/s.</p>
                                </div>
                                
                                <div className="label-wrapper">
                                <Form.Label className="request"><span className="required" >*</span>&nbsp;Province</Form.Label>
                                <Form.Control
                                required
                                as="select"
                                name="delivery_district"
                                onChange={(e) => {
                                    const selectedName = e.target.value;
                                    handleInputChange(e, setRequesterData)
                                
                                    // Find the full object from provinces
                                    const selectedOption = provinces.find(district => district.name === selectedName);
                                    if (selectedOption) {
                                        setSelectedProvince({ prv_code: selectedOption.prv_code, name: selectedOption.name });
                                    }
                                }}
                                >
                                <option value="">Select a Province</option>
                                {provinces.map((district) => (
                                    <option key={district.prv_code} value={district.name}>
                                    {district.name}
                                    </option>
                                ))}
                                </Form.Control>

                                <Form.Label className="request"><span className="required" >*</span>&nbsp;City</Form.Label>
                                <Form.Control
                                required
                                as="select"
                                name="delivery_city"
                                onChange={(e) => {
                                    const selectedName = e.target.value;
                                    handleInputChange(e, setRequesterData)
                                    
                                    const selectedOption = cities.find(city => city.name === selectedName);
                                    if (selectedOption) {
                                        setSelectedCity({ mun_code: selectedOption.mun_code, name: selectedOption.name });
                                    }
                                }}
                                >
                                
                                {selectedProvince ? (
                                    cities.map((city) => (
                                        <option key={city.mun_code} value={city.name}>
                                            {city.name}
                                        </option>
                                    ))
                                ) : (
                                  <option value="">Select Province First!</option>
                                )
                                }
                                </Form.Control>

                                <Form.Label className="request"><span className="required" >*</span>&nbsp;Barangay</Form.Label>
                                <Form.Control
                                required
                                as="select"
                                name="delivery_brgy"
                                onChange={(e) => handleInputChange(e, setRequesterData)}
                                >

                                {selectedCity ? (
                                    brgys.map((b) => (
                                        <option key={b.bgy_code} value={b.name}>
                                            {b.name}
                                        </option>
                                    ))
                                ) : (
                                  <option value="">Select City First!</option>
                                )
                                }
                                </Form.Control>


                                <div className="label-wrapper">
                                <Form.Label className="request"><span className="required">*</span>&nbsp;Street</Form.Label>
                                <div style={{ display: "flex", gap: "5px" }}>
                                    {/* Street Name */}
                                    <Form.Control
                                    required
                                    type="text"
                                    name="street_part1"
                                    maxLength="50"
                                    onChange={(e) => handleStreetInputChange(e, setRequesterData, "delivery_street")}
                                    placeholder="Street Name"
                                    />
                                    {/* House No. / Unit No. */}
                                    <Form.Control
                                    required
                                    type="text"
                                    name="street_part2"
                                    maxLength="10"
                                    onChange={(e) => handleStreetInputChange(e, setRequesterData, "delivery_street")}
                                    placeholder="House No. / Unit No."
                                    />
                                </div>
                                </div>

                                {/* Debugging: Display the combined delivery_street value */}
                                {/* <Form.Label className="request"><strong>Full Address:</strong> {dataRequester.delivery_street || "Waiting for input..."}</Form.Label> */}
                                </div>
                            </div>
                        ) :(
                            ""
                        )
                        }
                        
                        <p className="instructions"><strong>CAUTION:</strong> Only upload images with KB file size.</p>
                        <Form.Group controlId="file_portrait">
                            <div className="label-wrapper">
                              {/* <span className="required" >*</span>&nbsp; */}
                              <Form.Label className="request">Upload 2x2 Picture</Form.Label>
                              <p className='subtxt'><em>(If your request does not include <strong>Transcript of Records (TOR)</strong>, leave this field blank.)</em></p>
                              <p className='subtxt'><strong>Allowed file types:</strong>&nbsp;.jpg, .png&nbsp;and <strong>NO transparency for .png</strong> files.</p>
                              <Form.Control
                                // required
                                ref={filePortraitRef}  
                                type="file" 
                                name="file_portrait"
                                accept="image/png, image/jpeg" 
                                onChange={handlePortraitChange}
                              />
                            
                            
                            </div>
                        </Form.Group>
                        
                        {selectedPortrait && (
                            <div className="mt-4">
                                <p>2x2 Preview:</p>
                                <img
                                src={displayPortrait || "https://placehold.co/100x60"}
                                alt="Your 2x2 portrait"
                                title="Your 2x2 portrait"
                                className="preview-portrait"
                                />
                            </div>
                        )}

                        </article>
                    </Form>

                    <div className="submit-section">
                        <Button className="submit-btn" type="button" onClick={() => setShowPaymentModal(true)}>
                            Submit Request
                        </Button>
                    </div>
                </div>

                {/* Success Modal */}
                <Modal centered show={showSuccessModal} onHide={handleCloseSuccessModal} backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title>Thank You for Your Request</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {errorEmailConfirmation && (
                            <Alert variant={errorEmailConfirmation.type}>
                                {errorEmailConfirmation.message}
                            </Alert>
                        )
                        }
                        <p>
                        Reference Number:
                        {/* 
                        {displayRefNumbers.map((item, index) => (
                            <div key={index}>
                              <strong>{item}</strong>
                            </div>
                        ))}
                        */}
                          <div>
                            <strong>{referenceNumber}</strong>
                          </div>
                        </p>

                        <p>
                        Service:
                        {` For ${claimMode}`}    
                        </p>

                        <p>
                        Payment Method:
                        {` ${selectedPaymentMethod}`}    
                        </p>

                        <p>
                          <strong>Total Amount Due:</strong>{` ₱${dataDocument.total_price}`}
                        </p>

                    </Modal.Body>
                    <Modal.Footer>
                        {emailConfirmed && (
                            <Button variant="secondary" onClick={handleCloseSuccessModal}>
                            OK
                            </Button>
                        )}

                        {/* <Button variant="primary" onClick={() => {
                            setShowSuccessModal(false);
                            setShowPaymentModal(true);
                            }}>
                            Select Your Payment Method
                        </Button> */}

                        {/* <Button variant="secondary" onClick={handleCloseSuccessModal}>
                            Close
                        </Button> */}
                    </Modal.Footer>
                </Modal>

                {/* Payment Selection Modal */}
                <Modal centered show={showPaymentModal} onHide={() => setShowPaymentModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Select Payment Method</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Please choose your preferred payment method:</p>
                    <Form>
                        <Form.Group>
                            <Form.Check
                                type="radio"
                                label="Over the Counter"
                                name="paymentMethod"
                                value="Over the Counter"
                                onChange={(e) => setSelectedPaymentMethod(e.target.value)}
                                checked={selectedPaymentMethod === "Over the Counter"}
                            />
                            {/* TODO more options will appear after selecting online banking */}
                            <Form.Check
                                type="radio"
                                label="Online Banking"
                                name="paymentMethod"
                                value="Online Banking"
                                onChange={(e) => setSelectedPaymentMethod(e.target.value)}
                                checked={selectedPaymentMethod === "Online Banking"}
                            />
                            <Form.Check
                                type="radio"
                                label="GCash"
                                name="paymentMethod"
                                value="GCash"
                                onChange={(e) => setSelectedPaymentMethod(e.target.value)}
                                checked={selectedPaymentMethod === "GCash"}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button 
                        variant="primary" 
                        onClick={(e) => {
                            if (selectedPaymentMethod) {
                                // alert(`You selected: ${selectedPaymentMethod}`);
                                setShowPaymentModal(false);
                                handleFormSubmit(e);
                            } else {
                                alert("Please select a payment method.");
                            }
                        }} 
                        disabled={!selectedPaymentMethod}
                    >
                        Confirm Payment Method
                    </Button>

                    <Button variant="secondary" onClick={() => setShowPaymentModal(false)}>
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>

            </div>
            <ToastContainer newestOnTop/>
        </div>
    );
}
